import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import Tooltip from '@mui/material/Tooltip';

export default function ButtonMore({
    onClick,
    icon,
    disabled,
    title,
    children,
}: {
    onClick?: () => void;
    icon: React.ReactNode | string;
    disabled?: boolean;
    title?: string;
    children: React.ReactNode;
}) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="">
      <Tooltip title={title} placement="bottom">
      <Button
        onClick={handleClick}
        disabled={disabled}
        className='!min-w-[24px]'
      >
        {icon}
      </Button>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {children}
      </Menu>
    </div>
  );
}